module.exports = __webpack_public_path__ + "translations/en/upload.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/upload.json
// module id = ./translations/en/upload.json
// module chunks = 1